export class MapperColumns {
	headerName: string;
	autoHeight: boolean;
	width: number;
	field?: string;
	cellRenderer?: string;
	cellRendererParams?: CellRendererParams;

	constructor() {
		this.width = 120;
		this.autoHeight = false;
		this.field = '';
		this.cellRenderer = '';
		this.cellRenderer = null;
	}
}

export class CellRendererParams {
	listItems?: Array<any>;
	fieldId: string;
	fieldName: string;
	listItemName: string;
}

export const MAPPER_CONFIGS = {
	PROPERTY_TYPES: {
		urlApi: 'property-types',
		appScopes: 'globalConfiguration.appScope.propertyTypes',
		acuities: 'globalConfiguration.acuity.propertyTypes',
		cmpAcuities: 'globalConfiguration.cmpAcuity.propertyTypes',
		formFieldType: 'selectListCellRenderer'
	},
	LOAN_TYPES: {
		urlApi: 'loan-types',
		appScopes: 'globalConfiguration.appScope.loanTypes',
		acuities: 'globalConfiguration.acuity.loanTypes',
		cmpAcuities: 'globalConfiguration.cmpAcuity.loanTypes',
		formFieldType: 'selectListCellRenderer'
	},
	LOAN_REASONS: {
		urlApi: 'loan-reasons',
		appScopes: 'globalConfiguration.appScope.loanReasons',
		acuities: 'globalConfiguration.acuity.loanReasons',
		cmpAcuities: 'globalConfiguration.cmpAcuity.loanReasons',
		formFieldType: 'selectListCellRenderer'
	},
	OCCUPANCY_TYPES: {
		urlApi: 'occupancy-types',
		appScopes: 'globalConfiguration.appScope.occupancyTypes',
		acuities: 'globalConfiguration.acuity.occupancyTypes',
		cmpAcuities: 'globalConfiguration.cmpAcuity.occupancyTypes',
		formFieldType: 'selectListCellRenderer'
	},
	ONHOLD_REASONS: {
		urlApi: 'onhold-reasons',
		appScopes: '',
		acuities: '',
		cmpAcuities:'',
		formFieldType: 'textBoxCellRenderer'
	},
	DOCUMENT_TYPES: {
		urlApi: 'document-types',
		appScopes: 'globalConfiguration.appScope.documentTypes',
		acuities: 'globalConfiguration.acuity.documentTypes',
		cmpAcuities:'globalConfiguration.cmpAcuity.documentTypes',
		formFieldType: 'selectListCellRenderer'
	},
	MILESTONE_MESSAGES: {
		urlApi: 'milestones',
		appScopes: 'globalConfiguration.appScope.milestoneMessages',
		acuities: 'globalConfiguration.acuity.milestoneMessages',
		formFieldType: 'selectListCellRenderer'
	},
	DEFAULT_SETTINGS: {
		urlApi: 'default-settings',
		appScopes: 'globalConfiguration.appScope.defaultSettings',
		acuities: 'globalConfiguration.acuity.defaultSettings',
		formFieldType: 'selectListCellRenderer'
	}
}
